 export const isEncoded =  (uri)=> {
    uri = uri || '';
  
    return uri !== decodeURIComponent(uri);
  }